import vuex from 'vuex'
import Vue from 'vue'
Vue.use(vuex)

const recursos = {
    state: {
        tabseleccionado: 0, 
        variablesPND:[]
    },
    actions: {
        setselectedtab({commit}, payload){
            commit('SET_SELECTED_TAB', payload)        
        },
        saveVrblesPND({commit}, payload){
            commit('SET_vrbles_PND', payload) 
        }
    },
    mutations: {
        SET_SELECTED_TAB(state, selectedtab) {
            state.tabseleccionado = selectedtab
        },
        SET_vrbles_PND(state, variables) {
            if (variables.length > 0)
            {
                state.variablesPND[1] = variables[1]; //Punto
                state.variablesPND[2] = variables[2]; //Nivel
                state.variablesPND[3] = variables[3]; //Linea
                state.variablesPND[4] = variables[4]; //plannacionaldesarrollo
            } else
            {
                state.variablesPND = variables;
            }
        }
    },
    getters: {
        gtabseleccionado(state)
        {
            return state.tabseleccionado
        },
        getVariablesPND(state)
        {
            return state.variablesPND
        }
    }
}

export default recursos;
